export default __webpack_public_path__ + "static/media/09-yes-and.a9e9f67e.svg";